// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f80e42d8","453":"589cc308","455":"868f7577"}[chunkId] + ".chunk.js";
};